<template>
  <div class="schedulingContainer pa-3">
    <div class="d-flex align-center">
      Start/End dates:
      <v-menu
        v-model="isCalendarMenuOpen"
        :close-on-content-click="false"
        :nudge-right="0"
        transition="slide-y-reverse-transition"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <span
            v-on="on"
            class="startEndDate text-h6 ml-3"
            :style="{ 'font-size': isMobileSized ? '18px !important' : '' }"
          >
            {{ mediaChannelDateRange }}
            <v-icon>mdi-calendar</v-icon>
          </span>
        </template>
        <v-row no-gutters class="selectorMenu">
          <v-col>
            <p class="mb-0 pl-3 pt-3 font-weight-black">Starting</p>
            <v-date-picker
              no-title
              :max="mediaChannelEndDate == '' ? '' : mediaChannelEndDate"
              :min="currentDate"
              v-model="mediaChannelStartDate"
              reactive
            >
              <v-spacer></v-spacer>
              <v-btn text @click="mediaChannelStartDate = ''">Immediate</v-btn>
            </v-date-picker>
          </v-col>
          <v-col class="ml-2">
            <p class="mb-0 pl-3 pt-3 font-weight-black">Ending</p>
            <v-date-picker
              no-title
              v-model="mediaChannelEndDate"
              :min="mediaChannelStartDate == '' ? currentDate : mediaChannelStartDate"
              reactive
            >
              <v-spacer></v-spacer>
              <v-btn text @click="mediaChannelEndDate = ''">Never Expires</v-btn>
            </v-date-picker>
          </v-col>
        </v-row>
      </v-menu>
    </div>
    <div class="d-flex" style="flex-wrap: wrap;">
      <v-switch
        v-for="i in 7"
        :key="`Row${i}`"
        v-model="activityConfig[i - 1].Active"
        color="teal"
        :label="activityConfig[i - 1].Day | capitalize"
        style="transform:scale(.8); margin-top:0; padding-top:0; margin-left: -10px;"
        hide-details
      ></v-switch>
    </div>
  </div>
</template>

<script>
import {
  DEFAULT_ACTIVITY_CONFIG,
  DEFAULT_FREEMIUM_ACTIVITY_CONFIG,
} from '../configs/defaultMediaChannelConfigs'

export default {
  props: {
    schedule: {
      type: Object,
      undefined,
    },
    isQuickStart: {
      type: Boolean,
      default: false,
    },
    isMobileSized: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCalendarMenuOpen: false,
      mediaChannelStartDate: '',
      mediaChannelEndDate: '',
      currentDate: new Date().toISOString(),
      daysOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      activityConfig: JSON.parse(
        JSON.stringify(
          this.isQuickStart ? DEFAULT_ACTIVITY_CONFIG : DEFAULT_FREEMIUM_ACTIVITY_CONFIG
        )
      ),
    }
  },
  mounted() {
    if (this.schedule) {
      this.mediaChannelStartDate = this.schedule.mediaChannelStartDate
      this.mediaChannelEndDate = this.schedule.mediaChannelEndDate
      this.activityConfig = JSON.parse(JSON.stringify(this.schedule.activityConfig))
    }
    this.$emit('updateSchedule', this.scheduleData)
  },
  methods: {
    isDateScheduled(date) {
      date = !date ? '1970-01-01' : date
      return date != '1970-01-01'
    },
  },
  computed: {
    scheduleData() {
      return {
        activityConfig: this.activityConfig,
        mediaChannelStartDate: this.mediaChannelStartDate || '1970-01-01',
        mediaChannelEndDate: this.mediaChannelEndDate || '1970-01-01',
      }
    },
    mediaChannelDateRange() {
      let resultText = `${this.mediaChannelStartDate} to ${this.mediaChannelEndDate}`
      if (
        !this.isDateScheduled(this.mediaChannelStartDate) &&
        !this.isDateScheduled(this.mediaChannelEndDate)
      ) {
        // Immediate to Never Expires
        resultText = 'Always On'
      } else if (
        !this.isDateScheduled(this.mediaChannelStartDate) &&
        this.isDateScheduled(this.mediaChannelEndDate)
      ) {
        // Immediate to <actual end date>
        resultText = `Ends ${this.mediaChannelEndDate}`
      } else if (
        this.isDateScheduled(this.mediaChannelStartDate) &&
        !this.isDateScheduled(this.mediaChannelEndDate)
      ) {
        // <actual start date> to Never Expires
        resultText = `Always On, Starting ${this.mediaChannelStartDate}`
      }

      return resultText
    },
  },
  watch: {
    mediaChannelStartDate() {
      this.guibus_publish('dispatch:beacon', {
        eventId: `welcome-scheduling_update_media_channel_start_date-click${
          this.isMobileSized ? '-mobile' : ''
        }`,
      })
      this.$emit('updateSchedule', this.scheduleData)
    },
    mediaChannelEndDate() {
      this.guibus_publish('dispatch:beacon', {
        eventId: `welcome-scheduling_update_media_channel_end_date-click${
          this.isMobileSized ? '-mobile' : ''
        }`,
      })
      this.$emit('updateSchedule', this.scheduleData)
    },
    activityConfig: {
      handler() {
        this.guibus_publish('dispatch:beacon', {
          eventId: `welcome-scheduling_update_activity_config-click${
            this.isMobileSized ? '-mobile' : ''
          }`,
        })
        this.$emit('updateSchedule', this.scheduleData)
      },
      deep: true,
    },
    isCalendarMenuOpen(val) {
      if (val) {
        this.guibus_publish('dispatch:beacon', {
          eventId: `welcome-scheduling_open_calendar_menu-click${
            this.isMobileSized ? '-mobile' : ''
          }`,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.schedulingContainer {
  background-color: white;
  border-radius: 10px;
}
.selectorMenu {
  background-color: white;
}
.startEndDate {
  color: #aa00ff;

  i:before {
    color: #aa00ff;
  }

  &:hover {
    cursor: pointer;
    color: #d500f9;

    i:before {
      color: #d500f9;
    }
  }
}
</style>
